import { api } from './configs/axiosConfig';

const endPoint = "/guests";

export const guestAPI = {
    searchGuest: async function (key) {
        const reponse = await api.request({
            url: `${endPoint}/search-guests`,
            method: 'GET',
            params: { key }
        });

        return reponse.data;
    }
}